module.exports = __webpack_public_path__ + "static/hardwood-d5ecc0e4eacd7c5f07e20ad404a91fc9.jpg";